import React, { Component } from 'react'
import { Modal, Button } from 'react-bootstrap'
import {reduxForm, Field} from 'redux-form'
import { Row, Col } from 'react-bootstrap'
import './ModalRegistroIntervencionSanitaria.scss'
import ListadoPage from '../../../containers/page/ListadoPage'
import InputCheckBox from '../../comun/form/InputCheckBox'
import InputSelect from '../../comun/form/InputSelect'
import { DoneAll } from '@material-ui/icons'
import {estadoVerraco as estadoVerracoConstants} from '../../../constants/estadoVerraco'
import {estadoVerraco as estadoVerracoStilyzer} from '../../comun/table/Stilyzers'
import { Warning } from '@material-ui/icons'

class ModalVerracoRegistroIntervencionSanitaria extends Component {
  constructor () {
    super()
    this.state = {
      errorAnadirVerracos: false,
      fitrosSeleccionados: []
    }
  }

  anadirVerracoModalRegistroIntervencionSanitaria (values) {
    const itemsSeleccion = this.props.registroIntervencionSanitaria.listVerracosEnRegistroIntervencionSanitaria.map((row) => {
      return this.props.formSimpleTable.values['check' + row.idElemento] === true && (
        {
          'check': this.props.formSimpleTable.values['check' + row.idElemento],
          'idVerraco': row.idVerraco
        }
      )
    })
    let list = itemsSeleccion.filter(function (item) {
      return item.check === true;
    });
    if (list.length > 0){
      this.props.actions.anadirVerracoModalRegistroIntervencionSanitaria(list)
      this.setState({errorAnadirVerracos: false})
      this.closeModalAnadirVerraco()
    } else {
      this.setState({errorAnadirVerracos: true})
    }
    this.props.change('seleccionar-todos-modal-verraco-registro-intervencion-sanitaria', false)
  }

  guardarYnuevoGrupoVerraco(values){
    this.props.actions.guardarYnuevoGrupoVerraco(values)
  }

  intercambiarCheckModalVerracosRegistroIntervencionSanitaria (value) {
    if (value === true) {
      this.props.actions.seleccionarTodosModalVerracoRegistroIntervencionSanitaria()
    } else {
      this.props.actions.deSeleccionarTodosModalVerracoRegistroIntervencionSanitaria()
    }
  }

  componentDidMount () {
    this.props.actions.comboVerraco({},true)
    this.props.actions.comboRaza()
    this.props.actions.comboLineaGenetica()
    this.props.actions.comboUbicacionPadre()
    this.props.actions.comboNombreGrupoVerracoActiva()
    this.props.change('estado', {value: 3, label: this.props.t('COMUN.COMBOS.COMBO_ESTADO_VERRACO.ACTIVO')})
    let valores = []
    valores.estado = {value: 3, label: this.props.t('COMUN.COMBOS.COMBO_ESTADO_VERRACO.ACTIVO')}
    valores.list = Object.values(this.props.registroIntervencionSanitaria.verracosAnadidos)
    this.props.actions.fetchFiltrarVerracoModalRegistroIntervencionSanitaria(valores)
  }

  componentDidUpdate (prevProps) {
    if (this.props.registroIntervencionSanitaria.verracosAnadidos !== prevProps.registroIntervencionSanitaria.verracosAnadidos) {
      this.props.change('idVerraco', null)
      this.props.change('idRaza', null)
      this.props.change('idLinea', null)
      this.props.change('estado', {value: 3, label: this.props.t('COMUN.COMBOS.COMBO_ESTADO_VERRACO.ACTIVO')})
      this.props.change('idUbicacion', null)
      this.props.change('grupoVerraco', null)
      let valores = []
      valores.estado = {value: 3, label: this.props.t('COMUN.COMBOS.COMBO_ESTADO_VERRACO.ACTIVO')}
      valores.list = Object.values(this.props.registroIntervencionSanitaria.verracosAnadidos)
      this.props.actions.fetchFiltrarVerracoModalRegistroIntervencionSanitaria(valores)
    }
  }

  fetchFiltrarVerracoModalRegistroIntervencionSanitaria (values) {
    values.list = Object.values(this.props.registroIntervencionSanitaria.verracosAnadidos)
    this.props.actions.fetchFiltrarVerracoModalRegistroIntervencionSanitaria(values)
  }

  closeModalAnadirVerraco(){
    this.props.actions.cerrarModalVerracoRegistroIntervencionSanitaria()
    this.props.change('idVerraco', null)
    this.props.change('idRaza', null)
    this.props.change('idLinea', null)
    this.props.change('estado', {value: 3, label: this.props.t('COMUN.COMBOS.COMBO_ESTADO_VERRACO.ACTIVO')})
    this.props.change('idUbicacion', null)
    this.props.change('grupoVerraco', null)
    this.props.change('seleccionar-todos-modal-verraco-registro-intervencion-sanitaria', false)
    this.props.actions.deSeleccionarTodosModalVerracoRegistroIntervencionSanitaria()
    if (Object.keys(this.props.registroIntervencionSanitaria.filtrosModalVerracoRegistroIntervencionSanitaria).length > 0) {
      this.props.registroIntervencionSanitaria.filtrosModalVerracoRegistroIntervencionSanitaria.idVerraco = null
      this.props.registroIntervencionSanitaria.filtrosModalVerracoRegistroIntervencionSanitaria.idRaza = null
      this.props.registroIntervencionSanitaria.filtrosModalVerracoRegistroIntervencionSanitaria.idLinea = null
      this.props.registroIntervencionSanitaria.filtrosModalVerracoRegistroIntervencionSanitaria.estado = {value: 3, label: this.props.t('COMUN.COMBOS.COMBO_ESTADO_VERRACO.ACTIVO')}
      this.props.registroIntervencionSanitaria.filtrosModalVerracoRegistroIntervencionSanitaria.idUbicacion = null
      this.props.registroIntervencionSanitaria.filtrosModalVerracoRegistroIntervencionSanitaria.grupoVerraco = null
    }
    let valores = []
    valores.estado = {value: 3, label: this.props.t('COMUN.COMBOS.COMBO_ESTADO_VERRACO.ACTIVO')}
    valores.list = Object.values(this.props.registroIntervencionSanitaria.verracosAnadidos)
    this.props.actions.fetchFiltrarVerracoModalRegistroIntervencionSanitaria(valores)
    this.setState({fitrosSeleccionados: valores})
  }

  quitarFiltros (value) {
    let values = this.props.registroIntervencionSanitaria.filtrosModalVerracoRegistroIntervencionSanitaria
    values[value] = null
    this.props.actions.fetchFiltrarVerracoModalRegistroIntervencionSanitaria(values)
    this.props.change(value, null)
    this.setState({fitrosSeleccionados: values})
  }

  render () {
    const {
      t, handleSubmit, numeroRegistrosPorPagina, paginaActual,
      actions: { cerrarModalVerracoRegistroIntervencionSanitaria },
      combos: {comboRaza, comboLineaGenetica, comboUbicacionPadre, comboVerraco, comboNombreGrupoVerracoActiva},
      registroIntervencionSanitaria: {showModalVerracoRegistroIntervencionSanitaria, listVerracosEnRegistroIntervencionSanitaria, checkedVerracosRegistroIntervencionSanitaria, filtrosModalVerracoRegistroIntervencionSanitaria}
    } = this.props

    let comboEstadoVerracoNoEliminado = this.props.combos.comboEstadoVerracoNoEliminado
    comboEstadoVerracoNoEliminado = comboEstadoVerracoNoEliminado.map((estadoVerraco) => {
      return {...estadoVerraco, label: t(estadoVerraco.label)}
    })

    listVerracosEnRegistroIntervencionSanitaria.forEach(
      (row) => row.idElemento = row.idVerraco
    )

    const tableVerracos = {
      id: 'verracosTable',
      multiHeader: false,
      hasCheckbox: true,
      hasOptions: false,
      mostrarModificar: false,
      columns: [
        {id: 'codVerraco', name: t('PLAN_SANITARIO.REGISTRO_INTERVENCION_SANITARIA.MODAL.TABLA.NOMBRE')},
        {id: 'nombreRaza', name: t('PLAN_SANITARIO.REGISTRO_INTERVENCION_SANITARIA.MODAL.TABLA.RAZA')},
        {id: 'nombreLinea', name: t('PLAN_SANITARIO.REGISTRO_INTERVENCION_SANITARIA.MODAL.TABLA.LINEA_GENETICA')},
        {id: 'estadoverraco', name: t('PLAN_SANITARIO.REGISTRO_INTERVENCION_SANITARIA.MODAL.TABLA.ESTADO'), stilyzer: estadoVerracoStilyzer},
        {id: 'ubicacionverraco', name:  t('PLAN_SANITARIO.REGISTRO_INTERVENCION_SANITARIA.MODAL.TABLA.UBICACION')},
        {id: 'index', name: t('PLAN_SANITARIO.REGISTRO_INTERVENCION_SANITARIA.MODAL.TABLA.INDEX')}
      ],
      rows: listVerracosEnRegistroIntervencionSanitaria,
      rowsVerraco: true,
      initialValues: {},
      colorearRow: (row) => {
        switch(row.estadoverraco) {
          case estadoVerracoConstants.CUARENTENA:
            return 'verraco-en-cuarentena';
          case estadoVerracoConstants.PRESENTADO:
            return 'verraco-en-presente';
          case estadoVerracoConstants.ACTIVO:
            return 'verraco-en-activo';
          case estadoVerracoConstants.BAJA:
            return 'verraco-en-baja';
          case estadoVerracoConstants.ELIMINADO:
            return 'verraco-en-eliminado';
          default:
            return 'verraco-en-ningun-estado';
        }
      }
    }

    tableVerracos.rows.forEach(
      (row, idRow) => {
        if (idRow >= numeroRegistrosPorPagina * (paginaActual - 1) && idRow < numeroRegistrosPorPagina * paginaActual) {
          tableVerracos.initialValues['check' + row.idElemento] = checkedVerracosRegistroIntervencionSanitaria
        }
      }
    )

    return (
      <Modal show={showModalVerracoRegistroIntervencionSanitaria} onHide={() => this.closeModalAnadirVerraco()} aria-labelledby="contained-modal-title-lg" size="lg" className="modal-grupo-verraco">
        <Modal.Header closeButton>
          <Modal.Title>
            {t('GRUPOS_VERRACO.MODAL.VERRACOS_ASIGNAR')}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Row>
            <Col sm={12}>
              <div className="tabla-filtros-modal-grupo-verracos">
                <form className="custom-form">
                  <Field
                    colSm={2}
                    id="grupoVerraco"
                    name="grupoVerraco"
                    controlLabel={t('PLAN_SANITARIO.REGISTRO_ALIMENTACION.FILTROS.GRUPO_VERRACO')}
                    component={InputSelect}
                    options={comboNombreGrupoVerracoActiva}
                    valueKey="value"
                    labelKey="label"
                    customClass='select-ubicacion'
                    onInputChange={handleSubmit(this.fetchFiltrarVerracoModalRegistroIntervencionSanitaria.bind(this))}
                  />
                  <Field
                    colSm={2}
                    id="idVerraco"
                    name="idVerraco"
                    controlLabel={t('FICHA_VERRACO.FILTROS.VERRACO')}
                    component={InputSelect}
                    options={comboVerraco}
                    valueKey="value"
                    labelKey="label"
                    customClass='select-verraco'
                    onInputChange={handleSubmit(this.fetchFiltrarVerracoModalRegistroIntervencionSanitaria.bind(this))}
                  />
                  <Field
                    colSm={2}
                    id="idRaza"
                    name="idRaza"
                    controlLabel={t('FICHA_VERRACO.FILTROS.RAZA')}
                    component={InputSelect}
                    options={comboRaza}
                    valueKey="value"
                    labelKey="label"
                    customClass='select-raza'
                    onInputChange={handleSubmit(this.fetchFiltrarVerracoModalRegistroIntervencionSanitaria.bind(this))}
                  />
                  <Field
                    colSm={2}
                    id="idLinea"
                    name="idLinea"
                    controlLabel={t('FICHA_VERRACO.FILTROS.LIN_GENETICA')}
                    component={InputSelect}
                    options={comboLineaGenetica}
                    valueKey="value"
                    labelKey="label"
                    customClass='select-lin-genetica'
                    onInputChange={handleSubmit(this.fetchFiltrarVerracoModalRegistroIntervencionSanitaria.bind(this))}
                  />
                  <Field
                    colSm={2}
                    id="estado"
                    name="estado"
                    controlLabel={t('FICHA_VERRACO.FILTROS.ESTADO_VERRACO')}
                    component={InputSelect}
                    options={comboEstadoVerracoNoEliminado}
                    valueKey="value"
                    labelKey="label"
                    customClass='select-estado-verraco'
                    onInputChange={handleSubmit(this.fetchFiltrarVerracoModalRegistroIntervencionSanitaria.bind(this))}
                  />
                  <Field
                    colSm={2}
                    id="idUbicacion"
                    name="idUbicacion"
                    controlLabel={t('CAMBIO_ESTADO_VERRACOS.FILTROS.UBICACION')}
                    component={InputSelect}
                    options={comboUbicacionPadre}
                    valueKey="value"
                    labelKey="label"
                    customClass='select-ubicacion'
                    onInputChange={handleSubmit(this.fetchFiltrarVerracoModalRegistroIntervencionSanitaria.bind(this))}
                  />
                  <div className="clearfix"></div>
                  <div className="aplicar-tabla-filtros">
                    <div className="filtros-anadidos">
                      {
                        Object.keys(filtrosModalVerracoRegistroIntervencionSanitaria).length > 0 && (
                          filtrosModalVerracoRegistroIntervencionSanitaria.grupoVerraco && filtrosModalVerracoRegistroIntervencionSanitaria.grupoVerraco !== null ? (
                            <span className="badge-dark">{t('PLAN_SANITARIO.REGISTRO_ALIMENTACION.FILTROS.GRUPO_VERRACO') + ': ' + filtrosModalVerracoRegistroIntervencionSanitaria.grupoVerraco.label}<button type="button" className="quitar-filtro" onClick={() => this.quitarFiltros('grupoVerraco')}> x </button></span>
                          ) : null
                        )
                      }
                      {
                        Object.keys(filtrosModalVerracoRegistroIntervencionSanitaria).length > 0 && (
                          (filtrosModalVerracoRegistroIntervencionSanitaria.idVerraco && filtrosModalVerracoRegistroIntervencionSanitaria.idVerraco !== null && filtrosModalVerracoRegistroIntervencionSanitaria.idVerraco !== '') ? (
                            <span className="badge-dark">{t('FICHA_VERRACO.FILTROS.VERRACO') + ': ' + filtrosModalVerracoRegistroIntervencionSanitaria.idVerraco.label}<button type="button" className="quitar-filtro" onClick={() => this.quitarFiltros('idVerraco')}> x </button></span>
                          ) : null
                        )
                      }
                      {
                        Object.keys(filtrosModalVerracoRegistroIntervencionSanitaria).length > 0 && (
                          filtrosModalVerracoRegistroIntervencionSanitaria.idRaza && filtrosModalVerracoRegistroIntervencionSanitaria.idRaza !== null ? (
                            <span className="badge-dark">{t('FICHA_VERRACO.FILTROS.RAZA') + ': ' + filtrosModalVerracoRegistroIntervencionSanitaria.idRaza.label}<button type="button" className="quitar-filtro" onClick={() => this.quitarFiltros('idRaza')}> x </button></span>
                          ) : null
                        )
                      }
                      {
                        Object.keys(filtrosModalVerracoRegistroIntervencionSanitaria).length > 0 && (
                          filtrosModalVerracoRegistroIntervencionSanitaria.idLinea && filtrosModalVerracoRegistroIntervencionSanitaria.idLinea !== null ? (
                            <span className="badge-dark">{t('FICHA_VERRACO.FILTROS.LIN_GENETICA') + ': ' + filtrosModalVerracoRegistroIntervencionSanitaria.idLinea.label}<button type="button" className="quitar-filtro" onClick={() => this.quitarFiltros('idLinea')}> x </button></span>
                          ) : null
                        )
                      }
                      {
                        Object.keys(filtrosModalVerracoRegistroIntervencionSanitaria).length > 0 && (
                          filtrosModalVerracoRegistroIntervencionSanitaria.estado && filtrosModalVerracoRegistroIntervencionSanitaria.estado !== null ? (
                            <span className="badge-dark">{t('FICHA_VERRACO.FILTROS.ESTADO_VERRACO') + ': ' + filtrosModalVerracoRegistroIntervencionSanitaria.estado.label}<button type="button" className="quitar-filtro" onClick={() => this.quitarFiltros('estado')}> x </button></span>
                          ) : null
                        )
                      }
                      {
                        Object.keys(filtrosModalVerracoRegistroIntervencionSanitaria).length > 0 && (
                          filtrosModalVerracoRegistroIntervencionSanitaria.idUbicacion && filtrosModalVerracoRegistroIntervencionSanitaria.idUbicacion !== null ? (
                            <span className="badge-dark">{t('CAMBIO_ESTADO_VERRACOS.FILTROS.UBICACION') + ': ' + filtrosModalVerracoRegistroIntervencionSanitaria.idUbicacion.label}<button type="button" className="quitar-filtro" onClick={() => this.quitarFiltros('idUbicacion')}> x </button></span>
                          ) : null
                        )
                      }
                    </div>
                    <div className="clearfix"></div>
                  </div>
                </form>
              </div>
            </Col>
            <div className="tabla-verracos-en-grupo-verracos">
              <div className="filtros-tabla-modal-grupo-verracos">
                <div className="custom-check-w">
                  <Field
                    id="seleccionar-todos-modal-verraco-registro-intervencion-sanitaria"
                    name="seleccionar-todos-modal-verraco-registro-intervencion-sanitaria"
                    inline
                    component={InputCheckBox}
                    onInputChange={(value) => this.intercambiarCheckModalVerracosRegistroIntervencionSanitaria(value)}
                  />
                </div>
              </div>
              <ListadoPage t_key="GRUPOS_VERRACO." noTitle={true} table={tableVerracos}>
              </ListadoPage>
              {
                this.state.errorAnadirVerracos === true && <p className="error-verracos"><Warning/>{t('PLAN_SANITARIO.REGISTRO_INTERVENCION_SANITARIA.MODAL.DEBE_INCLUIR_VERRACO')}</p>
              }
            </div>
          </Row>
        </Modal.Body>
        <Modal.Footer>
          <Button type="submit" className="btn btn-primary" onClick={handleSubmit(this.anadirVerracoModalRegistroIntervencionSanitaria.bind(this))}>{t('GRUPOS_VERRACO.MODAL.ANADIR')}</Button>
          <Button type="button" className="btn btn-white" onClick={() => this.closeModalAnadirVerraco()}>{t('GRUPOS_VERRACO.MODAL.CANCELAR')}</Button>
        </Modal.Footer>
      </Modal>
    )
  }
}

export default (reduxForm({
  form: 'ModalVerracoRegistroIntervencionSanitaria',
  enableReinitialize: true
})(ModalVerracoRegistroIntervencionSanitaria))